import { render, staticRenderFns } from "./BaseImage.vue?vue&type=template&id=000bf7b2&"
import script from "./BaseImage.vue?vue&type=script&lang=js&"
export * from "./BaseImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports